<template>
  <dx-button
    :type="type"
    @click="onClick"
    :disabled="disabled"
    :style="style"
    :hint="hint"
  >
    <template>
      <span class="active-button-internal">
        <dx-load-indicator
          :visible="busy"
          class="button-indicator"
        />
        <i v-if="icon" class="dx-icon" :class="iconClass"></i>
        <font-awesome-icon v-if="faIcon" class="dx-icon" :icon="faIcon" />
        <span v-if="text" class="dx-button-text"> {{ text }}</span>
      </span>
    </template>
  </dx-button>
</template>

<script>
import { DxButton, DxLoadIndicator } from 'devextreme-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: "aims2-button",
  props: {
    icon: String,
    faIcon: String,
    type: String,
    color: String,
    text: String,
    hint: String,
    disabled: Boolean,
    busy: Boolean
  },
  components: { DxButton, DxLoadIndicator, FontAwesomeIcon },
  computed: {
    iconClass() {
      const ic = {};
      if (this.icon) {
        ic[`dx-icon-${this.icon}`] = true;
      }
      return ic;
    },
    style() {
      return this.color? { 'background-color': this.color }: null;
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e.event.metaKey || e.event.ctrlKey);
    }
  }
}
</script>

<style lang="scss">
span.active-button-internal {
  display: flex;
  flex-direction: row;
  align-items: center;

  .dx-button-text {
    margin-left: 3px;
  }
}

.dx-button.dx-state-disabled {
  .active-button-internal {
    position: relative;

    .button-indicator {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 24px;
      width: 24px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      .dx-loadindicator-icon {
        .dx-loadindicator-segment {
          background: white;
        }
      }
    }
  }
}
</style>
